import { render, staticRenderFns } from "./LogoUploader.vue?vue&type=template&id=5861c832&scoped=true"
import script from "./LogoUploader.vue?vue&type=script&lang=ts"
export * from "./LogoUploader.vue?vue&type=script&lang=ts"
import style0 from "./LogoUploader.vue?vue&type=style&index=0&id=5861c832&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5861c832",
  null
  
)

export default component.exports